import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config'; 

export const appCon = {
  providers: [
    ...appConfig.providers,
  ]
}

bootstrapApplication(AppComponent, appCon)
  .catch((err) => console.error(err));
